import React from "react";
import aboutBg from "./assets/bg_about.jpg";
import logo_sst from "./assets/logo_sst.svg";


{/* Features Section */}
export default function About() {
    return (
<section id="about" className="relative pl-8   px-4 py-6 w-full mx-auto max-w-[101.25rem] min-h-[37.5rem] bg-cover bg-center bg-no-repeat  " style={{ backgroundImage: `url(${aboutBg})` }}>

    <h2 className=" relative bg-black text-white w-fit p-2 text-4xl font-semibold ">About</h2>

    <p className="mt-2 lg:mt-[2rem] max-w-[33rem]  text-white  md:text-2xl	 relative">
Autonomous Machines is a deeptech venture born from a collaboration between    <a href="https://stonesouptech.com" target="_blank" className="underline">Stone Soup Tech</a>  , regional energy specialists, and top-tier academic researchers—including the head of the robotics department at the University of Bucharest and AI faculty from the University of Würzburg. Focused on developing fully autonomous robotic systems for solar park construction, our mission is to make construction safer, faster, and more efficient through cutting-edge innovation in robotics and AI.

</p>

    <div className="mt-10 md:mt-auto md:absolute md:bottom-8 left-8 md:flex md:flex-wrap gap-10 max-w-full">
        <img
            alt="another autonomous machine "
            src={logo_sst}
            className="h-auto w-[13.4375rem] mb-5 md:mb-0 "
        />

    </div>
</section>
    );
}